import { ICv } from 'types/cvsInterfaces'

export function selectPreferredCv({
  cvs,
  requestedCvId,
  defaultCvId,
}: {
  cvs: ICv[]
  requestedCvId?: number
  defaultCvId?: number
}): ICv | undefined {
  if (typeof requestedCvId === 'number') {
    const requestedCv = cvs.find(cv => cv.id === requestedCvId)
    if (requestedCv) {
      return requestedCv
    }
  }

  if (typeof defaultCvId === 'number') {
    const defaultCv = cvs.find(cv => cv.id === defaultCvId)
    if (defaultCv) {
      return defaultCv
    }
  }

  const originalCv = cvs.find(cv => cv.original)
  return originalCv ?? cvs[0]
}

export function removeCvAndChooseFallback({
  cvs,
  deletedCvId,
  selectedCvId,
}: {
  cvs: ICv[]
  deletedCvId: number
  selectedCvId?: number
}): {
  cvs: ICv[]
  selectedCv: ICv | undefined
} {
  const filtered = cvs.filter(cv => cv.id !== deletedCvId)
  const nextSelectedCv =
    typeof selectedCvId === 'number' && selectedCvId === deletedCvId && filtered.length > 0 ? filtered[0] : undefined

  return {
    cvs: filtered,
    selectedCv: nextSelectedCv,
  }
}
